// rich text card display
import CardStaticHtml from './card_templates/_card_static_html';

// NOTE: using PureComponent here to prevent (many) unnecessary card re-renders in battlecard view
class CardDisplay extends React.PureComponent {

  static contextTypes = {
    utils: PropTypes.object.isRequired
  };

  static propTypes = {
    card: PropTypes.object.isRequired,
    rival: PropTypes.object.isRequired,
    previewMode: PropTypes.bool,
    showTitle: PropTypes.bool
  };

  static defaultProps = {
    card: {},
    rival: {},
    previewMode: false,
    showTitle: false
  };

  componentDidMount() {
    console.log('CardDisplay.componentDidMount: props: %o', this.props);
  }

  render() {
    const {card, rival, previewMode} = this.props;
    const {id: cardId, templateName, data, board} = card || {};

    // friendly fallback
    if(_.isEmpty(card) || !templateName || _.isEmpty(data)) {
      return (
        <div className="search-result-card-content_empty">Sorry, this card can&apos;t be displayed. 😧</div>
      );
    }

    return <CardStaticHtml {...data} id={cardId} rival={rival} board={board} previewMode={previewMode} />;
  }

}

export default CardDisplay;
